import type React from 'react';
import type { OrderChange, OrderState } from '@/interfaces/data/OrderRepositoryInterface';
import { orderChangeFormatter } from '../../components/formatters';

export function RowChangeView(
  row: keyof OrderState,
  change: OrderChange,
  formatter = orderChangeFormatter
): React.JSX.Element {
  return (
    <div style={{ padding: 2 }} key={row}>
      {RowView(
        (formatter as Record<string, { name: string; format: (value: string) => string }>)[row].name
      )}{' '}
      {OldValueView(
        (formatter as Record<string, { name: string; format: (value: string) => string }>)[
          row
        ].format((change.old as Record<string, unknown>)[row] as string)
      )}
      {' →  '}
      {NewValueView(
        (formatter as Record<string, { name: string; format: (value: string) => string }>)[
          row
        ].format((change.new as Record<string, unknown>)[row] as string)
      )}
    </div>
  );
}

export const RowView = (child: React.ReactElement | string) => (
  <p
    style={{
      display: 'inline-block',
      background: '#1890ff',
      color: 'white',
      padding: '0 2px',
      margin: 0,
      borderRadius: 5,
    }}
  >
    {child}
  </p>
);

const OldValueView = (child: React.ReactElement | string) => (
  <span
    style={{
      // textDecoration: "line-through",
      color: '#AAA',
    }}
  >
    {child}
  </span>
);

const NewValueView = (child: React.ReactElement | string) => (
  <span
    style={{
      // textDecoration: "underline",
      textDecorationColor: '#5E5',
      color: '#1890ff',
    }}
  >
    {child}
  </span>
);
